import styled from "@emotion/styled";

export const Wrapper = styled("div")`
  label: Wrapper;
  height: 100vh;
  display: flex;
  background-color: #020230;
  color: white;
`;